import React, { Component } from 'react';

import S3 from 'react-aws-s3';
import classnames from 'classnames';
import Select from 'react-select';

import Breadcrumbs from '../../components/Common/Breadcrumb';
import FilePreviewerThumbnail from 'react-file-previewer';

import {
	Row,
	Table,
	Col,
	Card,
	CardBody,
	TabContent,
	TabPane,
	CardTitle,
	NavLink,
	Label,
	Input,
	Alert,
	Button,
	FormGroup,
	Container,
	CustomInput,
	CardImg,
	Collapse
} from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import data from '../../helpers/phoneCode.json';

import './Testimony.scss';
import { testimonyFormOptionsUrl, testimonyUrl, victimAddressUrl, victimAssessmentUrl, victimConsentUrl, victimContactUrl, victimDataUrl, victimDetentionUrl, victimDocumentUrl, victimHealthUrl, victimImageUrl, victimOccupationUrl, victimRemoveUrl, victimTagsUrl, victimTravelUrl, victimUrl, victimVerifiedUrl } from '../../helpers/url';

export default class TestimonyVerify extends Component {
	constructor(props) {
		super(props);
		this.state = {
			openExtraSection: false,
			breadcrumbItems: [
				{ title: 'Dashboard', link: '/dashboard' },
				{ title: 'Testimony List', link: '/testimonyList' },
				{ title: 'Testimony Registration', link: '/testimonyVerify' },
			],
			sectionMenu: [
				{ id: 1, icon: 'mdi mdi-account-arrow-left-outline', sectionTitle: 'Personalia', status: false },
				{ id: 2, icon: 'mdi mdi-map-marker-plus', sectionTitle: 'Address', status: false },
				{ id: 3, icon: 'mdi mdi-medical-bag', sectionTitle: 'Health status', status: false },
				{ id: 4, icon: 'mdi mdi-passport', sectionTitle: 'Documents', status: false },
				{ id: 5, icon: 'mdi mdi-database-plus', sectionTitle: 'General Data', status: false },
				{ id: 6, icon: 'mdi mdi-map-plus', sectionTitle: 'Travel History', status: false },
				{ id: 7, icon: 'mdi mdi-police-badge-outline', sectionTitle: 'Detention Status', status: false },
				{ id: 8, icon: 'mdi mdi-contacts-outline', sectionTitle: 'References', status: false },
				{ id: 9, icon: 'mdi mdi-pencil-lock-outline', sectionTitle: 'Consent', status: false },
				{ id: 10, icon: 'mdi mdi-alert-circle-check-outline', sectionTitle: 'Internal Assessment', status: false },
			],
			activeTab: 1,
			activeTabProgress: 1,
			success: [false, false, false, false, false, false, false, false, false, false],
			successMsg: ['', '', '', '', '', '', '', '', '', ''],
			error: false,
			errorMsg: null,
			fileSubmitError: false,
			fileSubmitErrorMsg: '',

			endpoints: [
				victimUrl,
				victimAddressUrl,
				victimHealthUrl,
				victimDocumentUrl,
				victimDataUrl,
				victimTravelUrl,
				victimDetentionUrl,
				victimContactUrl,
				victimConsentUrl,
				victimAssessmentUrl,
			],

			// tempVictimId used for all sections. Get updated in first section.
			tempVictimId: 0,

			// checks if section 1 is submitted
			submittedSection1: false,
			tempPid: 0,

			occupationId: 0,
            oId: 0, 

			// temp section address
			tempAddress: '',
			tempCity: '1',
			tempCategory: '1',
			tempNotes: '',
			tempId: 0,
			editing: false,

			// temp section health status
			tempHealthSituation: '0',
			tempClarification: '',
			tempDate: '',
			tempHealthId: 0,

			// temp section Documents
			tempDocumentType: '1',
			tempDocumentId: 0,
			tempDocumentIdNumber: '',
			tempDocumentNotes: '',
			tempDocumentIssuedBy: '',
			tempDocumentIssuedDate: '',
			tempDocumentLocation: '',
			tempDocumentDropLocation: [],

			tempDocumentImageDescription: "",
			tempDocumentImageType: 1,
			tempDocumentImageId: 0,
			tempDocumentImageLocation: "",
			imageSentSuccess: false,
            imageSentSuccessMessage: "",

			// temp section detention status
			tempDetentionId: 0,
			tempDetentionStatusId: '0',
			tempDetentionOther: '',
			tempDetentionClarification: '',
			tempDetentionReason: '',
			tempDetentionPossesionOfInformation: '',
			tempDetentionAddress: '',
			tempDetentionDocument: '',
			tempDetentionLocationId: 1,
			tempDetentionStatusYearFrom: '',
			tempDetentionStatusYearTo: '',
			tempDetentionStatusMonthFrom: '',
			tempDetentionStatusMonthTo: '',
			tempDetentionStatusDayTo: '',
			tempDetentionStatusDayFrom: '',

			// temp section reference
			tempReferenceContactId: 0,
			tempReferenceFirstname: '',
			tempReferenceLastname: '',
			tempReferenceAge: 0,
			tempReferencePlaceOfBirth: '',
			tempReferencePlaceOfBirthId: 0,
			tempReferenceGender: 2,
			tempReferenceRelation: '',
			tempReferenceEmail: '',
			tempReferenceMobile: '',

			// Assessment Select Multiple options
			tempAssessmentMultiSelect: [],

			// ConsentReq
			tempConsentsGetReq: [],

			//  object in final section delete status and message on delete
			sectionObjectDeleteStatus: false,
			sectionObjectDeleteMessage: '',

			confirmMessage: "",

			// final sections
			sections: {
				0: {
					victimId: 0,
					firstname: '',
					lastname: '',
					nickname: '',
					legalName: '',
					fullnameUEY: '',
					gender: 1,
					ethnicityId: 0,
					birthYear: 0,
					birthMonth: 0,
					birthDay: 0,
				},
				1: [],
				2: [],
				3: [],
				4: {
					dataId: 0,
					victimId: 0,
					religiosity: 0,
					maritalStatus: 0,
					educationLevel: 0,
					chineseLanguageSkills: 0,
					numberOfChildren: 0,
					partyMember: -1,
				},
				5: {
					travelId: 0,
					victimId: 0,
					abroadTravel: 0,
					haveFamilyAbroad: -1,
					visitedCountriesId: [],
					additionalInfo: '',
				},
				6: [],
				7: [],
				8: [],
				9: {
					assessmentId: 0,
					assessment: '',
					tags: [],
					signature: '',
					note: '',
					victimId: 0,
					userId: null,
				},
			},
			// ComponentDidMount data
			formFieldData: [],
			userFormData: [],
			// Loading until ComponentDidMount fetch request is complete
			loading: true,
			unFields: []
		};
		this.toggleTab.bind(this);
		this.stateHandling.bind(this);
	}

	getEarlierFormData = (victimId) => {
		const endpoints = [...this.state.endpoints];
		const endpointsWithOnlyVictimIdIdx = [0, 4, 8];
		for (let i = 0; i < endpoints.length; i++) {
			if (endpointsWithOnlyVictimIdIdx.includes(i)) {
				endpoints[i] = endpoints[i] + victimId;
			} else {
				endpoints[i] = `${endpoints[i]}${victimId}/0`
			}
		}
		for (let i = 0; i < endpoints.length; i++) {
			const session = JSON.parse(sessionStorage.getItem('authUser'));
			const accessToken = session.jwtToken;
			fetch(endpoints[i], {
				method: 'GET',
				headers: { 'Content-Type': 'application/json', "Authorization": accessToken },
			})
				.then(res => res.json())
				.then(data => {
					this.setState({
						sections: { ...this.state.sections, [i]: data },
					});
				})
                .catch(err => {
                    this.setState({
                        loading: false,
                        error: true,
                        errorMsg: err,
                    })
                })
            }
    }

	occupationHandling = () => {
        const session = JSON.parse(sessionStorage.getItem('authUser'));
		const userId = session.payload.sub;
		const accessToken = session.jwtToken;
        fetch(victimOccupationUrl, {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify({
                oId : this.state.oId,
                victimId : this.state.tempVictimId,
                userId : userId,
                occupationId : parseInt(this.state.occupationId),
            })
        }).then(res=>res.json())
        .then(data => {
            this.setState({
                oId: data.oid,
            })
        })
    }

    postFetch = (sectionNumber) => {
        if (this.state.tempVictimId !== 0 && sectionNumber === 0) {
            let tempOrderSummary = [...this.state.sectionMenu]
            tempOrderSummary[sectionNumber].status = true
            let successStatus = [...this.state.success]
            successStatus[sectionNumber] = true
            this.setState({
                sectionMenu: tempOrderSummary,
                success: successStatus
            })
            let consentArrayToUpdateVictimId = [...this.state.sections[8]]
            consentArrayToUpdateVictimId.forEach((each) => {
                each.victimId = this.state.tempVictimId
            })
            this.setState({
                tempVictimId: this.state.tempVictimId,
                submittedSection1: true,
                sections: {...this.state.sections,
                    8: consentArrayToUpdateVictimId,
                    4: {...this.state.sections[4],
                        victimId: this.state.tempVictimId
                    },
                    5: {...this.state.sections[5],
                        victimId: this.state.tempVictimId
                    },
                    9: {...this.state.sections[9],
                        victimId: this.state.tempVictimId
                    },
                }
            })
            return
        }
		const session = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = session.jwtToken;
        fetch(this.state.endpoints[sectionNumber], {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify(
                this.state.sections[sectionNumber]
            )
        })
        .then(res=>res.json())
        .then((data) => {
            if(data) {
                if (data.status && (data.status[0] === 4 || data.status[0] === 5)) {
                    this.setState({
                        error: true,
                        errorMsg: "Fetch request returned status 4xx."
                    })
                }
                else {
                    let dictOfSectionsLoopType = {1: "id", 2: "healthId", 3: "documentId", 6:"detentionId", 7: "contactId", 8: "victimConsentId"}
                    let dictOfSectionsSingleType = {4: "dataId", 9: "assessmentId", 5: "travelId"}
                    if (sectionNumber === 0) {
                        let consentArrayToUpdateVictimId = [...this.state.sections[8]]
                        consentArrayToUpdateVictimId.forEach((each) => {
                            each.victimId = data.victimId
                        })
                        this.setState({
                            tempVictimId: data.victimId,
                            submittedSection1: true,
                            sections: {...this.state.sections,
                                8: consentArrayToUpdateVictimId,
                                4: {...this.state.sections[4],
                                    victimId: data.victimId
                                },
                                5: {...this.state.sections[5],
                                    victimId: data.victimId
                                },
                                9: {...this.state.sections[9],
                                    victimId: data.victimId
                                },
                            }
                        })
						
                        fetch(victimVerifiedUrl + this.state.tempPid + '/' + data.victimId + "/0", {
                            method: "GET",
                            headers: {"Content-Type": "application/json", "Authorization": accessToken},
                            }) 
                            .then(res=>res.json())
                            .then((data) => {
                        })
                    }
                    else if (sectionNumber in dictOfSectionsLoopType) {
                        let tempSectionForUpdate = [...this.state.sections[sectionNumber]]
                        let idName = dictOfSectionsLoopType[sectionNumber]
                        for (let i=0; i < data.length; i++){
                            tempSectionForUpdate[i][idName] = data[i][idName]
                        }
                        this.setState({
                            sections: {...this.state.sections,
                                [sectionNumber]: tempSectionForUpdate
                            }
                        })
                    } 
                    else if (sectionNumber in dictOfSectionsSingleType) {
                        this.setState({
                            sections: {...this.state.sections,
                                [sectionNumber]: {...this.state.sections[sectionNumber],
                                    [dictOfSectionsSingleType[sectionNumber]]: data[dictOfSectionsSingleType[sectionNumber]] 
                                }
                            }
                        })
                        if (sectionNumber === 9 ) {
							let postApiUrl = victimVerifiedUrl +  this.state.tempPid + '/' + this.state.tempVictimId + "/1"
                            fetch(postApiUrl, {
                            method: "GET",
                            headers: {"Content-Type": "application/json", "Authorization": accessToken},
                            }) 
                            .then(res=>res.json())
                            .then((data) => {
                                if (data === 1) {
                                    this.props.history.push("/dashboard"); 
									this.setState({
										confirmMessage: "Successfully registered the testimony to the system with id: " + this.state.tempPid 
									});
                                }
                                else {
                                    this.setState({
                                        error: true,
                                        errorMessage: "Failed to submit last section"
                                    })
                                }
                            })
                            fetch('https://discord.com/api/webhooks/905495286426771546/cxOixHMmLugqZLT9h9JAABPbPHopzNFhNp3iKK32T28dzUIApYGPuVquGTlqZnjhgJ_r', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', "Authorization": accessToken},
                                body: JSON.stringify({
                                    "content": "Testimony is verified",
                                    "embeds": [{
                                            "title": this.state.sections[0].firstname + " " + this.state.sections[0].lastname + " has been registered with ID #:" + this.state.tempVictimId,
                                            "description" : "Testimony is verified by: " + this.state.sections[9].signature,
                                            "url": "https://www.utjd.org/missing/" + this.state.tempVictimId
                                    }] 
                                })
                            })
                            .then(res => res.json())
                            .catch((err) => {
                                this.setState({
                                    error: true, //fix
                                    errorMessage: "Failed: " + err
                                })
                            })
                        }
                    }
                    let tempOrderSummary = [...this.state.sectionMenu]
                    tempOrderSummary[sectionNumber].status = true
                    let successStatus = [...this.state.success]
                    successStatus[sectionNumber] = true
                    this.setState({
                        sectionMenu: tempOrderSummary,
                        success: successStatus
                    })
                }
            }
        })
        .catch( (err) => { 
            this.setState({
                error: true,
                errorMsg: err
            })
        })
    }

	componentDidMount() {
		let tempPid = this.props.location.state?.tempPid ? this.props.location.state.tempPid : "0";
		const session = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = session.jwtToken;
		this.setState({
			tempPid: tempPid,
		});
		let formFieldData = fetch(testimonyFormOptionsUrl, {
			method: 'GET',
			headers: { 'Content-Type': 'application/json', "Authorization": accessToken },
		}).then(res => res.json());
		let userFormData = fetch(testimonyUrl + (tempPid === "0" ? '' : tempPid), {
			method: 'GET',
			headers: { 'Content-Type': 'application/json', "Authorization": accessToken},
		}).then(res => res.json());
		let consentFieldData = fetch(victimConsentUrl, {
			method: 'GET',
			headers: { 'Content-Type': 'application/json', "Authorization": accessToken},
		}).then(res => res.json());
		let multiSelect = fetch(victimTagsUrl, {
			method: 'GET',
			headers: { 'Content-Type': 'application/json', "Authorization": accessToken},
		}).then(res => res.json());

		Promise.all([formFieldData, userFormData, consentFieldData, multiSelect])
			.then(([formFieldDataOutput, userFormDataOutput, consentFieldDataOutput, multiSelectOutput]) => {
				let tempGetConsent = [];
				consentFieldDataOutput.forEach(data => {
					tempGetConsent.push({
						consentId: data.consentId,
						consentName: data.consentName,
						description: data.description,
						clarification: data.clarification,
						victimConsentId: 0,
						victimId: this.state.tempVictimId,
						isAccepted: null,
					});
				});
				
				if (typeof userFormDataOutput.length === 'undefined') {
					let userFormDataOutputNew = JSON.parse(userFormDataOutput.formData);
					let vicId = JSON.parse(userFormDataOutput.victimId);
					if (vicId !== 0) {
						this.getEarlierFormData(vicId);
					}
					this.setState({
						tempConsentsGetReq: consentFieldDataOutput,
						tempAssessmentMultiSelect: multiSelectOutput,
						tempVictimId: vicId,
					});
					let unFields = {
						extraJobTitle: userFormDataOutputNew.jobTitle,
						extraEconomySituation: userFormDataOutputNew.economySituation,
						extraFamilyInfo: userFormDataOutputNew.familyInfo,
						extraCurrentSituation: userFormDataOutputNew.currentSituation,
						extraPlaceOfImprisonment: userFormDataOutputNew.placeOfImprisonment,
						extraReasonForDetainment: userFormDataOutputNew.reasonForDetainment,
						extraHealthSituation: userFormDataOutputNew.ealthSituation,
						extraReleased: userFormDataOutputNew.released,
						extraHavePassport: userFormDataOutputNew.havePassport,
						extraSelfCountry: userFormDataOutputNew.selfCountry,
					}
					this.setState({
						unFields: unFields
					})
					this.setState({
						tempAddress: userFormDataOutputNew.placeOfBirth,
						tempHealthSituation: userFormDataOutputNew.healthSituation,
						tempDocumentType: userFormDataOutputNew.havePassport === '1' ? '1' : '3',
						tempDocumentIdNumber:
							userFormDataOutputNew.havePassport === '1' ? userFormDataOutputNew.passportNumber : userFormDataOutputNew.idNumber,
						tempDetentionReason: userFormDataOutputNew.reasonForDetainment,
						tempReferenceFirstname: userFormDataOutputNew.selfFirstname,
						tempReferenceLastname: userFormDataOutputNew.selfLastname,
						tempReferencePlaceOfBirthId: userFormDataOutputNew.selfCountry,
						tempReferenceRelation: userFormDataOutputNew.selfConnection,
						tempReferenceEmail: userFormDataOutputNew.selfEmail,
						tempReferenceMobile: userFormDataOutputNew.selfPhoneNumber,
						formFieldData: formFieldDataOutput,
						loading: false,
						sections: {
							...this.state.sections,
							0: {
								...this.state.sections[0],
								victimId: 0,
								firstname: userFormDataOutputNew.firstname,
								lastname: userFormDataOutputNew.lastname,
								nickname: userFormDataOutputNew.middleName,
								gender: userFormDataOutputNew.gender === 'Male' ? 3 : 2,
							},
							4: {
								...this.state.sections[4],
								religiosity: parseInt(userFormDataOutputNew.religiousLevel),
								maritalStatus: parseInt(userFormDataOutputNew.marriage),
								educationLevel: parseInt(userFormDataOutputNew.educationLevel),
								chineseLanguageSkills: parseInt(userFormDataOutputNew.chineseLanguageLevel),
								partyMember: parseInt(userFormDataOutputNew.memberOfCCP),
							},
							5: { ...this.state.sections[5], additionalInfo: userFormDataOutputNew.familyInfo },
							8: tempGetConsent,
						},
					});
				} else {
					this.setState({
						tempConsentsGetReq: consentFieldDataOutput,
						tempAssessmentMultiSelect: multiSelectOutput,
						formFieldData: formFieldDataOutput,
						loading: false,
						sections: { ...this.state.sections, 8: tempGetConsent },
					});
				}
			})
			.catch(err => {
				this.setState({
					loading: false,
					error: true,
					errorMsg: err,
				});
			});
	}

	

	// changeState = (sectionNumber) => {
	//     let state = postFetch(this.state, sectionNumber)
	//     this.setState({
	//         state
	//     })
	// }

	tempStateEdit = (sectionNumber, id) => {
		let tempSection = [
			{
				tempAddress: this.state.sections[1][id]?.address,
				tempCategory: this.state.sections[1][id]?.type,
				tempCity: this.state.sections[1][id]?.codeId,
				tempNotes: this.state.sections[1][id]?.notes,
				tempId: this.state.sections[1][id]?.id,
				editing: true,
			},
			{
				tempHealthSituation: this.state.sections[2][id]?.status,
				tempClarification: this.state.sections[2][id]?.clarification,
				tempDate: this.state.sections[2][id]?.date.split('T')[0],
				tempHealthId: this.state.sections[2][id]?.healthId,
				editing: true,
			},
			{
				tempDocumentType: this.state.sections[3][id]?.type,
				tempDocumentId: this.state.sections[3][id]?.documentId,
				tempDocumentIdNumber: this.state.sections[3][id]?.idNumber,
				tempDocumentNotes: this.state.sections[3][id]?.notes,
				tempDocumentIssuedBy: this.state.sections[3][id]?.issuedBy,
				tempDocumentIssuedDate: this.state.sections[3][id]?.issuedDate.split('T')[0],
				tempDocumentLocation: this.state.sections[3][id]?.s3location,
				editing: true,
			},
			{},
			{},
			{
				tempDetentionAddress: this.state.sections[6][id]?.detentionAddress,
				tempDetentionClarification: this.state.sections[6][id]?.clarification,
				tempDetentionDocument: this.state.sections[6][id]?.document,
				tempDetentionId: this.state.sections[6][id]?.detentionId,
				tempDetentionLocationId: this.state.sections[6][id]?.locationId,
				tempDetentionOther: this.state.sections[6][id]?.other,
				tempDetentionPossesionOfInformation: this.state.sections[6][id]?.possesionOfInformation,
				tempDetentionReason: this.state.sections[6][id]?.reason,
				tempDetentionStatusId: this.state.sections[6][id]?.statusId,
				tempDetentionStatusDayFrom: this.state.sections[6][id]?.detainedFromDay,
				tempDetentionStatusDayTo: this.state.sections[6][id]?.detainedToDay,
				tempDetentionStatusMonthFrom: this.state.sections[6][id]?.detainedFromMonth,
				tempDetentionStatusMonthTo: this.state.sections[6][id]?.detainedToMonth,
				tempDetentionStatusYearFrom: this.state.sections[6][id]?.detainedFromYear,
				tempDetentionStatusYearTo: this.state.sections[6][id]?.detainedToYear,
				editing: true,
			},
			{
				tempReferenceContactId: this.state.sections[7][id]?.contactId,
				tempReferenceFirstname: this.state.sections[7][id]?.person.firstName,
				tempReferenceLastname: this.state.sections[7][id]?.person.lastName,
				tempReferenceAge: this.state.sections[7][id]?.person.age,
				tempReferencePlaceOfBirth: this.state.sections[7][id]?.person.placeOfBirth,
				tempReferencePlaceOfBirthId: this.state.sections[7][id]?.person.placeOfBirthId,
				tempReferenceGender: this.state.sections[7][id]?.person.gender,
				tempReferenceRelation: this.state.sections[7][id]?.relation,
				tempReferenceEmail: this.state.sections[7][id]?.email,
				tempReferenceMobile: this.state.sections[7][id]?.mobile,
				editing: true,
			},
		];

		let tempSectionSelected = tempSection[sectionNumber - 1];
		this.setState(tempSectionSelected);
		let sectionArray = [...this.state.sections[sectionNumber]];
		sectionArray.splice(id, 1);
		this.setState({
			sections: { ...this.state.sections, [sectionNumber]: sectionArray },
		});
	};

	addressDelete = (sectionNumber, id, sectionName, sectionId, victimId) => {
		const session = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = session.jwtToken;
		if (sectionId !== 0) {
			let deleteUrlAddress = victimRemoveUrl + sectionName + '/' + sectionId + '/' + victimId + '/';
			fetch(deleteUrlAddress, {
				method: 'DELETE',
				headers: { 'Content-Type': 'application/json', "Authorization": accessToken},
			})
				.then(res => res.json())
				.then(data => {
					if (data && data.message === 'Data successfully removed from database.') {
						let section1Array = [...this.state.sections[sectionNumber]];
						section1Array.splice(id, 1);
						this.setState({
							sections: { ...this.state.sections, [sectionNumber]: section1Array },
						});
						this.setState({
							sectionObjectDeleteStatus: true,
							sectionObjectDeleteMessage: 'Successfully Deleted',
						});
					}
				})
				.catch(err => {
					this.setState({
						error: true,
						errorMsg: err,
					});
				});
		} else {
			let section1Array = [...this.state.sections[sectionNumber]];
			section1Array.splice(id, 1);
			this.setState({
				sections: { ...this.state.sections, [sectionNumber]: section1Array },
			});
			this.setState({
				sectionObjectDeleteStatus: true,
				sectionObjectDeleteMessage: 'Successfully Deleted This Address',
			});
		}
	};

	toggleTab(tab, type) {
		console.log(tab)
		if (this.state.activeTab !== tab) {
			if (tab >= 1 && tab <= 10) {
				this.setState({
					activeTab: tab,
				});
			}
		}
		if (type === 1) {
			this.postFetch(tab - 2);

			if (tab === 6) {
				this.occupationHandling();
			}
		}
	}

	assessmentStateSectionChange = event => {
		const session = JSON.parse(sessionStorage.getItem('authUser'));
		const userId = session.payload.sub;
		this.setState({
			sections: { ...this.state.sections, 9: { ...this.state.sections[9], [event.target.id]: event.target.value, userId: userId } },
		});
	};

	concentAcceptedUpdate = (event, idx) => {
		let tempSection8 = this.state.sections[8];
		if (event.target.value === '1') {
			tempSection8[idx].isAccepted = true;
		} else if (event.target.value === '0') {
			tempSection8[idx].isAccepted = false;
		}
		this.setState({
			sections: { ...this.state.sections, 8: tempSection8 },
		});
	};

	fileSubmitToS3 = async (file, sectionName, documentCategory) => {
		const config = {
			bucketName: process.env.REACT_APP_BUCKET_NAME,
			region: process.env.REACT_APP_REGION,
			accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
			secretAccessKey: process.env.REACT_APP_SECRET_KEY_ID,
		};
		const ReactS3Client = new S3(config);
		await ReactS3Client.uploadFile(file, 'testimony/' + this.state.tempVictimId + '/' + sectionName + '/' + documentCategory + '/' + file.name)
			.then(data => {
				if (data && data.location) {
					if (sectionName === 'detention') {
						this.setState({
							tempDetentionDocument: data.location,
						});
					} else if (sectionName === 'document') {
						this.setState({
							tempDocumentLocation: data.location,
						});
					}
					else if (sectionName === 'image') {
						this.setState({
							tempDocumentImageLocation: data.location
						})
					}
				} else {
					this.setState({
						error: true,
						errorMsg: 'File could not be uploaded',
					});
				}
			})
			.catch(err => {
				this.setState({
					error: true,
					errorMsg: err.message,
				});
			});
	};

	fileDropSubmitToS3 = async (file, sectionName, documentCategory) => {
		const config = {
			bucketName: process.env.REACT_APP_BUCKET_NAME,
			region: process.env.REACT_APP_REGION,
			accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
			secretAccessKey: process.env.REACT_APP_SECRET_KEY_ID,
		};
		const ReactS3Client = new S3(config);
		await ReactS3Client.uploadFile(file, 'testimony/' + this.state.tempVictimId + '/' + sectionName + '/' + documentCategory + '/' + file.name)
			.then(data => {
				if (data && data.location) {
					console.log(data.location);
					this.setState({
						tempDocumentDropLocation: [...this.state.tempDocumentDropLocation, data.location]
					})
					this.submitDropDocument(data.location);
				} else {
					this.setState({
						error: true,
						errorMsg: 'File could not be uploaded',
					});
				}
			})
			.catch(err => {
				this.setState({
					error: true,
					errorMsg: err.message,
				});
			});
	};

	submitDropDocument = async (location) => {
		const session = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = session.jwtToken;
        fetch(victimDocumentUrl, {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify([{
                type: 5,
                idNumber: "",
                s3location: location,
                notes: "Multiple Drop Documents",
                issuedBy: "",
                issuedDate: new Date(),
                victimId: this.state.tempVictimId,
                documentId: 0
            }])
        }).then(res=>res.json())
        .then(data => {
            console.log(data);
        })
    }

	fileHandling = async (event, sectionName) => {
		let fileUploadingSections = ['document', 'detention', 'image'];
		let correspondingOptionTypes = [
			this.state.tempDocumentType ? parseInt(this.state.tempDocumentType) - 1 : 3,
			2, //this.state.tempDetentionStatusId ? parseInt(this.state.tempDetentionStatusId) : 3,
			this.state.tempDocumentImageType ? parseInt(this.state.tempDocumentImageType) - 1 : 3,
		];
		let optionTypeNameList = [
			['PASSPORT', 'NATIONALIDCARD', 'OTHERS', 'Null'],
			['Test1', 'Test2', 'Test3', 'Null'],
			['Profile Image', 'Family Photo', 'Other']
		];
		let indexOfUploadSections = fileUploadingSections.indexOf(sectionName);
		let optionTypeSelection = optionTypeNameList[indexOfUploadSections];
		let optionTypeSelectionIndex = optionTypeSelection[correspondingOptionTypes[indexOfUploadSections]];
		if (event.target.files[0] !== null) {
			await this.fileSubmitToS3(event.target.files[0], sectionName, optionTypeSelectionIndex);
		}
	};

	fileDropHandling = async (event, sectionName) => {
		if (event.target.files !== null && event.target.files.length > 0) {
			for (let file of event.target.files) {
				await this.fileDropSubmitToS3(file, sectionName, 5);
			}
		}
	};

	stateSelect = (selected, section) => {
		let ListOfStateNameToChange = { 5: 'visitedCountriesId', 9: 'tempAssessmentMultiSelect' };
		let SelectedStateNameToChange = ListOfStateNameToChange[section - 1];
		let selectedOptions = [];
		if (section === 6) {
			selected.map(each => selectedOptions.push(each.value));
			this.setState({
				sections: {
					...this.state.sections,
					[section - 1]: { ...this.state.sections[section - 1], [SelectedStateNameToChange]: selectedOptions },
				},
			});
		} else if (section === 10) {
			selected.map(each => {
				if (each.value === 1) {
					selectedOptions.push(this.state.tempAssessmentMultiSelect[0]);
				} else if (each.value === 2) {
					selectedOptions.push(this.state.tempAssessmentMultiSelect[1]);
				} else if (each.value === 3) {
					selectedOptions.push(this.state.tempAssessmentMultiSelect[2]);
				}
			});
			let tempState = { ...this.state.sections[section - 1] };
			tempState.tags = selectedOptions;
			this.setState({
				sections: { ...this.state.sections, [section - 1]: tempState },
			});
		}
	};

	stateHandling = (event, nr) => {
		let targetId = event.target.id;
		let targetValue = event.target.value;
		let targetType = event.target.type;
		if (targetType === 'text' || targetType === 'textarea') {
			this.setState({
				sections: {
					...this.state.sections,
					[nr]: {
						...this.state.sections[nr],
						[targetId]: targetValue,
					},
				},
			});
		} else if (targetType === 'number' || targetType === 'select-one') {
			if (targetValue === isNaN) {
				targetValue = 0;
			}
			if (targetId === 'abroadTravel') {
				if (parseInt(targetValue) !== 2) {
					this.setState({
						sections: {
							...this.state.sections,
							5: { ...this.state.sections[5], visitedCountriesId: (this.state.sections[5].visitedCountriesId.length = 0) },
						},
					});
				}
			}
			this.setState({
				sections: {
					...this.state.sections,
					[nr]: {
						...this.state.sections[nr],
						[targetId]: parseInt(targetValue),
					},
				},
			});
		} else if (targetType === 'radio') {
			this.setState({
				sections: {
					...this.state.sections,
					[nr]: {
						...this.state.sections[nr],
						[event.target.name]: parseInt(event.target.value),
					},
				},
			});
		}
	};

	responseHandling = event => {
		this.setState({
			[event.target.id]: false,
			[event.target.id + 'Msg']: '',
		});
	};

	tempStateHandling = event => {
		if (event.target.type === 'radio') {
			this.setState({
				[event.target.name]: parseInt(event.target.value),
			});
		} else {
			this.setState({
				[event.target.id]: event.target.value,
			});
		}
	};

	addTempStateToSections = sectionNumber => {
		let tempToSection = [
			{
				address: this.state.tempAddress,
				type: parseInt(this.state.tempCategory),
				codeId: parseInt(this.state.tempCity),
				notes: this.state.tempNotes,
				id: this.state.tempId,
				victimId: this.state.tempVictimId,
			},
			{
				status: parseInt(this.state.tempHealthSituation),
				clarification: this.state.tempClarification,
				date: this.state.tempDate + 'T05:47:30Z',
				victimId: this.state.tempVictimId,
				healthId: this.state.tempHealthId,
			},
			{
				type: parseInt(this.state.tempDocumentType),
				documentId: this.state.tempDocumentId,
				idNumber: this.state.tempDocumentIdNumber,
				notes: this.state.tempDocumentNotes,
				issuedBy: this.state.tempDocumentIssuedBy,
				issuedDate: this.state.tempDocumentIssuedDate + 'T00:00:10Z',
				victimId: this.state.tempVictimId,
				s3location: this.state.tempDocumentLocation,
			},
			{},
			{},
			{
				detentionAddress: this.state.tempDetentionAddress,
				clarification: this.state.tempDetentionClarification,
				document: this.state.tempDetentionDocument,
				detentionId: this.state.tempDetentionId,
				locationId: parseInt(this.state.tempDetentionLocationId),
				other: this.state.tempDetentionOther,
				possesionOfInformation: this.state.tempDetentionPossesionOfInformation,
				reason: this.state.tempDetentionReason,
				statusId: parseInt(this.state.tempDetentionStatusId),
				detainedFromDay: this.state.tempDetentionStatusDayFrom === '' ? 0 : parseInt(this.state.tempDetentionStatusDayFrom),
				detainedToDay: this.state.tempDetentionStatusDayTo === '' ? 0 : parseInt(this.state.tempDetentionStatusDayTo),
				detainedFromMonth: this.state.tempDetentionStatusMonthFrom === '' ? 0 : parseInt(this.state.tempDetentionStatusMonthFrom),
				detainedToMonth: this.state.tempDetentionStatusMonthTo === '' ? 0 : parseInt(this.state.tempDetentionStatusMonthTo),
				detainedFromYear: this.state.tempDetentionStatusYearFrom === '' ? 0 : parseInt(this.state.tempDetentionStatusYearFrom),
				detainedToYear: this.state.tempDetentionStatusYearTo === '' ? 0 : parseInt(this.state.tempDetentionStatusYearTo),
				victimId: this.state.tempVictimId,
			},
			{
				contactId: this.state.tempReferenceContactId,
				person: {
					firstName: this.state.tempReferenceFirstname,
					lastName: this.state.tempReferenceLastname,
					age: parseInt(this.state.tempReferenceAge),
					placeOfBirth: this.state.tempReferencePlaceOfBirth,
					placeOfBirthId: parseInt(this.state.tempReferencePlaceOfBirthId),
					gender: parseInt(this.state.tempReferenceGender),
				},
				relation: this.state.tempReferenceRelation,
				email: this.state.tempReferenceEmail,
				mobile: this.state.tempReferenceMobile,
				victimId: this.state.tempVictimId,
			},
		];

		let selectedSection = tempToSection[sectionNumber - 1];
		this.setState({
			sections: {
				...this.state.sections,
				[sectionNumber]: [...this.state.sections[sectionNumber], selectedSection],
			},
		});
		let resetTempState = [
			{
				tempAddress: '',
				tempCategory: '1',
				tempCity: '1',
				tempNotes: '',
				tempId: 0,
				editing: false,
			},
			{
				tempHealthSituation: '0',
				tempClarification: '',
				tempDate: '',
				tempHealthId: 0,
				editing: false,
			},
			{
				tempDocumentType: '1',
				tempDocumentId: 0,
				tempDocumentIdNumber: '',
				tempDocumentNotes: '',
				tempDocumentIssuedBy: '',
				tempDocumentIssuedDate: '',
				tempDocumentLocation: '',
				tempDocumentDropLocation: [],
				editing: false,
			},
			{},
			{},
			{
				tempDetentionAddress: '',
				tempDetentionClarification: '',
				tempDetentionDocument: '',
				tempDetentionId: 0,
				tempDetentionLocationId: '0',
				tempDetentionOther: '',
				tempDetentionPossesionOfInformation: '',
				tempDetentionReason: '',
				tempDetentionStatusId: '1',
				tempDetentionStatusDayFrom: '',
				tempDetentionStatusDayTo: '',
				tempDetentionStatusMonthFrom: '',
				tempDetentionStatusMonthTo: '',
				tempDetentionStatusYearFrom: '',
				tempDetentionStatusYearTo: '',
				editing: false,
			},
			{
				tempReferenceContactId: 0,
				tempReferenceFirstname: '',
				tempReferenceLastname: '',
				tempReferenceAge: 0,
				tempReferencePlaceOfBirth: '',
				tempReferencePlaceOfBirthId: '1',
				tempReferenceGender: 2,
				tempReferenceRelation: '',
				tempReferenceEmail: '',
				tempReferenceMobile: '',
				editing: false,
			},
		];
		let selectedTemp = resetTempState[sectionNumber - 1];
		this.setState(selectedTemp);
	};

	tempPhoneCodeChange = event => {
		let countryCode = '';
		data.map((each, idx) => {
			if (each.name === event.target.value) {
				countryCode = each.dial_code;
			}
		});
		let phoneNumber = countryCode + this.state.tempReferenceMobile;
		this.setState({
			tempReferenceMobile: phoneNumber,
		});
	};

	submitImage = () => {
        const session = JSON.parse(sessionStorage.getItem('authUser'));
		const userId = session.payload.sub;
		const accessToken = session.jwtToken;
        fetch(victimImageUrl, {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify({
                type: parseInt(this.state.tempDocumentImageType),
                description: this.state.tempDocumentImageDescription,
                s3location: this.state.tempDocumentImageLocation,
                victimId: this.state.tempVictimId,
                imageId: this.state.tempDocumentImageId,
                userId: userId
            })
        }).then(res=>res.json())
        .then(data => {
            console.log(data);
            this.setState({
                imageSentSuccess: true,
                imageSentSuccessMessage: "Submitted! Go back to Testimony Manager and come back again."
            })
        })
    }

	render() {

		if (this.state.error === true) {
			return (
				<div className="page-content">
					<Container fluid>
						<div className="mt-5 text-center">
							<Alert
								id="error"
								color="error"
								isOpen={this.state.error}
								toggle={e => {
									this.setState({ error: !this.state.error });
								}}>
								{this.state.errorMessage}
							</Alert>
						</div>
					</Container>
				</div>
			);
		} else if (!this.state.loading) {
			return (
				<React.Fragment>
					<div className="page-content">
						<Container fluid>
							<Breadcrumbs title="Testimony Registration" breadcrumbItems={this.state.breadcrumbItems} />
							<Row>
								<Col lg="8">
									<Card>
										<CardBody>
											<div id="basic-pills-wizard" className="twitter-bs-wizard">
												<Alert
													id="error"
													color="error"
													isOpen={this.state.error}
													toggle={() => {
														this.setState({ error: !this.state.error });
													}}>
													{this.state.errorMsg}
												</Alert>
												<TabContent activeTab={this.state.activeTab} className="twitter-bs-wizard-tab-content">
													<TabPane tabId={1}>
														<CardTitle className="h5 mb-3 text-center">Personalia - Victim</CardTitle>
														<AvForm
															className="form-horizontal"
															onValidSubmit={() => {
																this.toggleTab(this.state.activeTab + 1, 1);
															}}>
															<FormGroup row>
																<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																	Given Name
																</Label>
																<Col md={8}>
																	<AvField
																		name="firstname"
																		className="form-control"
																		type="text"
																		placeholder="Isim"
																		id="firstname"
																		errorMessage="Enter Persons Given Name"
																		validate={{ required: { value: true } }}
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}
																		value={this.state.sections[0].firstname}
																	/>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																	Nickname
																</Label>
																<Col md={8}>
																	<Input
																		className="form-control"
																		type="text"
																		placeholder="Leqimi / Texellusi"
																		id="nickname"
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}
																		value={this.state.sections[0].nickname}
																	/>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																	Lastname
																</Label>
																<Col md={8}>
																	<AvField
																		name="lastname"
																		className="form-control"
																		type="text"
																		placeholder="Familisi"
																		id="lastname"
																		errorMessage="Enter Persons Last Name"
																		validate={{ required: { value: true } }}
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}
																		value={this.state.sections[0].lastname}
																	/>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																	Legal Name (Chinese)
																</Label>
																<Col md={8}>
																	<Input
																		className="form-control"
																		type="text"
																		placeholder="Legalname"
																		id="legalName"
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}
																		value={this.state.sections[0].legalName}
																	/>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																	Fullname (Uyghur)
																</Label>
																<Col md={8}>
																	<Input
																		className="form-control"
																		type="text"
																		placeholder="Full name in Uyghur"
																		id="fullnameUEY"
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}
																		value={this.state.sections[0].fullnameUEY}
																	/>
																</Col>
															</FormGroup>
															<FormGroup row onChange={event => this.stateHandling(event, this.state.activeTab - 1)}>
																<Label className="col-md-2 col-form-label">Gender</Label>
																<Col md={4}>
																	<div className="custom-control custom-radio mb-3">
																		<Input
																			type="radio"
																			id="genderMale"
																			value={3}
																			name="gender"
																			checked={this.state.sections[0].gender === 3}
																			className="custom-control-input"
																		/>
																		<Label className="custom-control-label" htmlFor="genderMale">
																			Male
																		</Label>
																	</div>
																</Col>
																<div className="custom-control custom-radio mb-3">
																	<Input
																		type="radio"
																		id="genderFemale"
																		value={2}
																		name="gender"
																		checked={this.state.sections[0].gender === 2}
																		className="custom-control-input"
																	/>
																	<Label className="custom-control-label" htmlFor="genderFemale">
																		Female
																	</Label>
																</div>
															</FormGroup>
															<FormGroup row>
																<Label className="col-md-2 col-form-label">Ethnicity</Label>
																<Col md={8}>
																	<select
																		className="custom-select"
																		name="number"
																		id="ethnicityId"
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}>
																		{this.state.formFieldData.ethnicities.map((data, id) => (
																			<option key={id} value={data.id}>
																				{data.ethnicityEN}
																			</option>
																		))}
																	</select>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
																	Birth Year
																</Label>
																<Col md={5}>
																	<Input
																		className="form-control"
																		type="number"
																		placeholder="Birth Year"
																		id="birthYear"
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}
																		value={this.state.sections[0].birthYear}
																	/>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
																	Birth Month
																</Label>
																<Col md={5}>
																	<Input
																		className="form-control"
																		type="number"
																		placeholder="Birth Month"
																		id="birthMonth"
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}
																		value={this.state.sections[0].birthMonth}
																	/>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
																	Birth Day
																</Label>
																<Col md={5}>
																	<Input
																		className="form-control"
																		type="number"
																		placeholder="Birth Day"
																		id="birthDay"
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}
																		value={this.state.sections[0].birthDay}
																	/>
																</Col>
															</FormGroup>
															<ul className="pager wizard twitter-bs-wizard-pager-link">
																<li className="next">
																	<Button to="#" type="submit">
																		Submit & Next
																	</Button>
																</li>
															</ul>
														</AvForm>
													</TabPane>

													<TabPane tabId={2}>
														<CardTitle className="h5 mb-3 text-center">
															Adresses - Victim {this.state.editing ? 'You are editing this address' : ''}
														</CardTitle>
														<AvForm
															className="form-horizontal"
															onValidSubmit={() => {
																this.toggleTab(this.state.activeTab + 1, 1);
															}}>
															<Card>
																<CardBody>
																	<FormGroup>
																		<Label htmlFor="billing-address" md="2" className="form-label">
																			Address
																		</Label>
																		<textarea
																			className="form-control"
																			value={this.state.tempAddress}
																			id="tempAddress"
																			rows="3"
																			placeholder="Enter address"
																			onChange={event => this.tempStateHandling(event)}
																		/>
																	</FormGroup>
																	<FormGroup row>
																		<Col lg={6}>
																			<div className="mb-4 mb-lg-0">
																				<Label className="form-label">City</Label>
																				<select
																					className="custom-select"
																					name="number"
																					id="tempCity"
																					value={this.state.tempCity}
																					onChange={event => this.tempStateHandling(event)}>
																					{this.state.formFieldData.landCodes.map((data, id) => (
																						<option key={id} value={data.codeId}>
																							{data.cityCountyEN}, {data.perfectureCityEN}
																						</option>
																					))}
																				</select>
																			</div>
																		</Col>
																		<Col lg={6}>
																			<div className="mb-4 mb-lg-0">
																				<Label className="form-label">Category</Label>
																				<select
																					className="custom-select"
																					value={this.state.tempCategory}
																					id="tempCategory"
																					onChange={event => this.tempStateHandling(event)}>
																					<option defaultValue value={1}>
																						Other
																					</option>
																					<option value={2}>Birth Place</option>
																					<option value={3}>Work Place</option>
																					<option value={4}>Education</option>
																					<option value={5}>Place of Residence</option>
																				</select>
																				{/*this.state.tempCategory === "1" ? 
                                                                   <FormGroup row>
                                                                        <Col md={12}>
                                                                            <Input className="form-control" type="text" placeholder="Write category (old house/ neighbour/ ...)" id="tempCategoryOther" onChange={(event) => this.tempStateHandling(event)}/>
                                                                        </Col>
                                                                    </FormGroup> 
                                                                    :
                                                                    ""
                                                                    */}
																			</div>
																		</Col>
																	</FormGroup>
																	<FormGroup>
																		<Label htmlFor="billing-address" md="2" className="form-label">
																			Notes
																		</Label>
																		<textarea
																			className="form-control"
																			value={this.state.tempNotes}
																			id="tempNotes"
																			rows="2"
																			placeholder="Notes"
																			onChange={event => this.tempStateHandling(event)}
																		/>
																	</FormGroup>
																	<FormGroup className="text-center">
																		<Button
																			color="primary"
																			type="button"
																			className="waves-effect waves-light me-1"
																			onClick={() => {
																				this.addTempStateToSections(this.state.activeTab - 1);
																			}}>
																			Add <i className="ri-arrow-right-line align-middle ms-2"></i>
																		</Button>
																		{/* <Button color="light" outline className="waves-effect me-1 align-center" size="lg" onClick={() => {this.addTempStateToSections(this.state.activeTab-1)}}>
                                                            Add
                                                        </Button> */}
																	</FormGroup>
																</CardBody>
															</Card>
															<Alert
																id="success"
																color="success"
																isOpen={this.state.sectionObjectDeleteStatus}
																toggle={e => {
																	this.setState({ sectionObjectDeleteStatus: !this.state.sectionObjectDeleteStatus });
																}}>
																{this.state.sectionObjectDeleteMessage}
															</Alert>
															<Row>
																{this.state.sections[1].map((element, id) => (
																	<Col lg={6} sm={6}>
																		<Card className="border rounded shipping-address" key={id}>
																			<CardBody>
																				<div className="text-center">
																					<Button
																						color="light"
																						className="waves-effect me-1 align-center"
																						onClick={() => {
																							this.tempStateEdit(this.state.activeTab - 1, id);
																						}}>
																						<div className="text-center">Edit</div>
																					</Button>
																				</div>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 text-left">Category:</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 text-right">{element.type}</h5>
																					</Col>
																				</Row>

																				<Row>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-left">Address</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-right">{element.address}</h5>
																					</Col>
																				</Row>
																				<p className="mb-0 text-center">{element.notes}</p>
																				<div className="text-center">
																					<Button
																						color="light"
																						className="waves-effect me-1 align-center"
																						onClick={() => {
																							if (window.confirm('Are you sure you want to delete this address?'))
																								this.addressDelete(
																									this.state.activeTab - 1,
																									id,
																									'address',
																									this.state.sections[this.state.activeTab - 1][id].id,
																									this.state.sections[this.state.activeTab - 1][id].victimId
																								);
																						}}>
																						<div className="text-center">Delete</div>
																					</Button>
																				</div>
																			</CardBody>
																		</Card>
																	</Col>
																))}
															</Row>

															<ul className="pager wizard twitter-bs-wizard-pager-link">
																<li className="previous">
																	<Button
																		to="#"
																		onClick={() => {
																			this.toggleTab(this.state.activeTab - 1, 0);
																		}}>
																		Previous
																	</Button>
																</li>
																<li className="next">
																	<Button to="#" disabled={!this.state.submittedSection1} type="submit">
																		Submit & Next
																	</Button>
																</li>
															</ul>
														</AvForm>
													</TabPane>

													<TabPane tabId={3}>
														<CardTitle className="h5 mb-3 text-center">Health status - Victim</CardTitle>
														<AvForm
															className="form-horizontal"
															onValidSubmit={() => {
																this.toggleTab(this.state.activeTab + 1, 1);
															}}>
															<Card>
																<CardBody>
																	<FormGroup row>
																		<Label className="col-md-2 col-form-label">
																			Health status {this.state.editing ? 'You are now editing Health Info' : ''}
																		</Label>
																		<Col md={8}>
																			<select
																				className="custom-select"
																				id="tempHealthSituation"
																				onChange={event => this.tempStateHandling(event)}
																				value={this.state.tempHealthSituation}>
																				{this.state.formFieldData.healthStatus.map((data, id) => (
																					<option key={id} value={data.hid}>
																						{data.statusEN}
																					</option>
																				))}
																			</select>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																			Additional info on health status
																		</Label>
																		<Col md={8}>
																			<Input
																				type="textarea"
																				id="tempClarification"
																				maxLength="1000"
																				rows="5"
																				placeholder="Additional health info about the victim"
																				value={this.state.tempClarification}
																				onChange={event => this.tempStateHandling(event)}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																			Date
																		</Label>
																		<Col md={8}>
																			<Input
																				type="date"
																				name="date"
																				id="tempDate"
																				placeholder="Date of this health situation YYYY-MM-DD"
																				onChange={event => this.tempStateHandling(event)}
																				value={this.state.tempDate}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup className="text-center">
																		<Button
																			color="primary"
																			type="button"
																			className="waves-effect waves-light me-1"
																			onClick={() => {
																				this.addTempStateToSections(this.state.activeTab - 1);
																			}}>
																			Add <i className="ri-arrow-right-line align-middle ms-2"></i>
																		</Button>
																	</FormGroup>
																</CardBody>
															</Card>

															<Alert
																id="success"
																color="success"
																isOpen={this.state.sectionObjectDeleteStatus}
																toggle={e => {
																	this.setState({ sectionObjectDeleteStatus: !this.state.sectionObjectDeleteStatus });
																}}>
																{this.state.sectionObjectDeleteMessage}
															</Alert>
															<Row>
																{this.state.sections[2].map((element, id) => (
																	<Col lg={6} sm={6}>
																		<Card className="border rounded shipping-address" key={id}>
																			<CardBody>
																				<div className="text-center">
																					<Button
																						color="light"
																						className="waves-effect me-1 align-center"
																						onClick={() => {
																							this.tempStateEdit(this.state.activeTab - 1, id);
																						}}>
																						<div className="text-center">Edit</div>
																					</Button>
																				</div>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 text-left">Health Situation</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 text-right">{element.status}</h5>
																					</Col>
																				</Row>

																				<Row>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-left">Clarification</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-right">{element.clarification}</h5>
																					</Col>
																				</Row>
																				<p className="mb-0 text-center">{element.date}</p>
																				<div className="text-center">
																					<Button
																						color="light"
																						className="waves-effect me-1 align-center"
																						onClick={() => {
																							if (window.confirm('Are you sure you want to delete this address?'))
																								this.addressDelete(
																									this.state.activeTab - 1,
																									id,
																									'health',
																									this.state.sections[this.state.activeTab - 1][id].healthId,
																									this.state.sections[this.state.activeTab - 1][id].victimId
																								);
																						}}>
																						<div className="text-center">Delete</div>
																					</Button>
																				</div>
																			</CardBody>
																		</Card>
																	</Col>
																))}
															</Row>
															<ul className="pager wizard twitter-bs-wizard-pager-link">
																<li className="previous">
																	<Button
																		to="#"
																		onClick={() => {
																			this.toggleTab(this.state.activeTab - 1, 0);
																		}}>
																		Previous
																	</Button>
																</li>
																<li className="next">
																	<Button to="#" disabled={!this.state.submittedSection1} type="submit">
																		Submit & Next
																	</Button>
																</li>
															</ul>
														</AvForm>
													</TabPane>

													<TabPane tabId={4}>
														<CardTitle className="h5 mb-3 text-center">Document - Victim</CardTitle>
														<AvForm
															className="form-horizontal"
															onValidSubmit={() => {
																this.toggleTab(this.state.activeTab + 1, 1);
															}}>
															<Card>
																<CardBody>
																	<FormGroup row>
																		<Label className="col-md-2 col-form-label">
																			Document Type{this.state.editing ? 'You are now editing Health Info' : ''}
																		</Label>
																		<Col md={8}>
																			<select
																				className="custom-select"
																				id="tempDocumentType"
																				onChange={event => this.tempStateHandling(event)}
																				value={this.state.tempDocumentType}>
																				<option value="1">Passport</option>
																				<option value="2">National ID Card</option>
																				<option value="3">Other</option>
																			</select>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																			Upload Document
																		</Label>
																		<Col md={8}>
																			<div className="custom-file mb-2">
																				<CustomInput
																					type="file" 
																					className="custom-file-input"
																					id="tempDocumentFileHolder"
																					onChange={event => {
																						this.fileHandling(event, 'document');
																					}}
																				/>
																				<Label className="custom-file-label" htmlFor="tempDocumentFileHolder">
																					Choose file
																				</Label>
																			</div>
																		</Col>
																		<Col md={8}>
																			<div className="testimony-file-preview text-center">
																				{this.state.tempDocumentLocation !== '' ? (
																					<FilePreviewerThumbnail
																						style={{ width: '100px' }}
																						hideControls={true}
																						file={{
																							url: this.state.tempDocumentLocation,
																						}}
																					/>
																				) : (
																					//<Label htmlFor="example-text-input" className="col-md-2 col-form-label">{this.state.tempDocumentLocation.substr(this.state.tempDocumentLocation.length - 3)} Ready</Label>

																					''
																				)}
																			</div>
																		</Col>
																	</FormGroup>

																	<Label htmlFor="example-text-input" className="col-md-10 col-form-label">
																		Documents Drop Section for multiple files upload. Files will be uploaded without description.
																	</Label>	
																	<FormGroup row>
																		<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																			Documents Drop
																		</Label>
																		<Col md={8}>
																			<div className="custom-file mb-2">
																				<CustomInput
																					type="file" multiple 
																					className="custom-file-input"
																					id="tempDocumentFileDropHolder"
																					onChange={event => {
																						this.fileDropHandling(event, 'drop');
																					}}
																				/>
																				<Label className="custom-file-label" htmlFor="tempDocumentFileDropHolder">
																					Choose files for Drop
																				</Label>
																			</div>
																		</Col>
																		<Col md={8}>
																			<div className="testimony-file-preview text-center">
																				Uploaded files {this.state.tempDocumentDropLocation.length}
																			</div>
																		</Col>
																	</FormGroup>
																	
																	<FormGroup row>
																		{/* <ProfileImageAdd victimId={this.state.tempVictimId}/> */}
																		<Label className="col-md-10 col-form-label">
																		<b>Upload Profile Image</b>
																		</Label>
																	</FormGroup>
																	<FormGroup row>
																		<Label className="col-md-2 col-form-label">
																			Image Type
																		</Label>
																		<Col md={8}>
																			<select
																				className="custom-select"
																				id="tempDocumentImageType"
																				onChange={event => this.tempStateHandling(event)}
																				value={this.state.tempDocumentImageType}>
																				<option value="1">Profile Image</option>
																				<option value="2">Family Photo</option>
																				<option value="3">Other</option>
																			</select>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label className="col-md-2 col-form-label">
																			Upload Photo
																		</Label>
																		<Col md={8}>
																			<div className="custom-file mb-2">
																				<CustomInput
																					type="file"
																					className="custom-file-input"
																					id="tempPhotoFileHolder"
																					onChange={event => {
																						this.fileHandling(event, 'image');
																					}}
																				/>
																				<Label className="custom-file-label" htmlFor="tempPhotoFileHolder">
																					Choose file
																				</Label>
																			</div>
																		</Col>
																	
																		<Col md={8}>
																			<div className="testimony-file-preview text-center">
																				{this.state.tempDocumentImageLocation !== '' ? (
																					<div>Uploaded</div>
																				) : (
																					//<Label htmlFor="example-text-input" className="col-md-2 col-form-label">{this.state.tempDocumentLocation.substr(this.state.tempDocumentLocation.length - 3)} Ready</Label>

																					''
																				)}
																			</div>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label className="col-md-2 col-form-label">
																			Description
																		</Label>
																		<Col md={8}>
																			<Input
																				className="form-control"
																				type="text"
																				placeholder="Please provide a description for the image"
																				id="tempDocumentImageDescription"
																				onChange={event => this.tempStateHandling(event)}
																				value={this.state.tempDocumentImageDescription}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup className="text-center">
																		<Button
																			color="primary"
																			type="button"
																			className="waves-effect waves-light me-1"
																			onClick={() => { this.submitImage() }}>
																			Submit <i className="ri-arrow-right-line align-middle ms-2"></i>
																		</Button>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																			ID Number
																		</Label>
																		<Col md={8}>
																			<Input
																				className="form-control"
																				type="text"
																				placeholder="Passport or National ID Number"
																				id="tempDocumentIdNumber"
																				onChange={event => this.tempStateHandling(event)}
																				value={this.state.tempDocumentIdNumber}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																			Issued By
																		</Label>
																		<Col md={8}>
																			<Input
																				className="form-control"
																				type="text"
																				placeholder="Document Issued By"
																				id="tempDocumentIssuedBy"
																				onChange={event => this.tempStateHandling(event)}
																				value={this.state.tempDocumentIssuedBy}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																			Issued Date
																		</Label>
																		<Col md={8}>
																			<Input
																				type="date"
																				name="date"
																				id="tempDocumentIssuedDate"
																				placeholder="Date of this health situation"
																				onChange={event => this.tempStateHandling(event)}
																				value={this.state.tempDocumentIssuedDate}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" md="2" className="form-label">
																			Notes
																		</Label>
																		<Col md={8}>
																			<textarea
																				className="form-control"
																				value={this.state.tempDocumentNotes}
																				id="tempDocumentNotes"
																				rows="2"
																				placeholder="Notes"
																				onChange={event => this.tempStateHandling(event)}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup className="text-center">
																		<Button
																			color="primary"
																			type="button"
																			className="waves-effect waves-light me-1"
																			onClick={() => {
																				this.addTempStateToSections(this.state.activeTab - 1);
																			}}>
																			Add <i className="ri-arrow-right-line align-middle ms-2"></i>
																		</Button>
																	</FormGroup>
																</CardBody>
															</Card>
															<Row>
																{this.state.sections[3].map((element, id) => (
																	<Col lg={6} sm={6}>
																		<Card className="border rounded shipping-address" key={id}>
																			<CardBody>
																				<div className="text-center">
																					<Button
																						color="light"
																						className="waves-effect me-1 align-center"
																						onClick={() => {
																							this.tempStateEdit(this.state.activeTab - 1, id);
																						}}>
																						<div className="text-center">Edit</div>
																					</Button>
																				</div>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 text-left">Document ID</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 text-right">{element.documentId}</h5>
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-left">ID Number</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-right">{element.idNumber}</h5>
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-left">Issued By</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-right">{element.issuedBy}</h5>
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-left">Issued Date</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-right">{element.issuedDate}</h5>
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-left">Notes</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-right">{element.notes}</h5>
																					</Col>
																				</Row>
																				<p className="mb-0 text-center">{element.date}</p>
																				{element.s3location.substr(element.s3location.length - 3) === 'pdf' ? (
																					<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																						PDF
																					</Label>
																				) : (
																					<CardImg top width="100%" src={element.s3location} />
																				)}
																				<div className="text-center">
																					<Button
																						color="light"
																						className="waves-effect me-1 align-center"
																						onClick={() => {
																							if (window.confirm('Are you sure you want to delete this address?'))
																								this.addressDelete(
																									this.state.activeTab - 1,
																									id,
																									'document',
																									this.state.sections[this.state.activeTab - 1][id].documentId,
																									this.state.sections[this.state.activeTab - 1][id].victimId
																								);
																						}}>
																						<div className="text-center">Delete</div>
																					</Button>
																				</div>
																			</CardBody>
																		</Card>
																	</Col>
																))}
															</Row>
															<ul className="pager wizard twitter-bs-wizard-pager-link">
																<li className="previous">
																	<Button
																		to="#"
																		onClick={() => {
																			this.toggleTab(this.state.activeTab - 1, 0);
																		}}>
																		Previous
																	</Button>
																</li>
																<li className="next">
																	<Button to="#" disabled={!this.state.submittedSection1} type="submit">
																		Submit & Next
																	</Button>
																</li>
															</ul>
														</AvForm>
													</TabPane>

													<TabPane tabId={5}>
														<CardTitle className="h5 mb-3 text-center">Additional Data - Victim</CardTitle>
														<AvForm
															className="form-horizontal"
															onValidSubmit={() => {
																this.toggleTab(this.state.activeTab + 1, 1);
															}}>
															<FormGroup row>
																<Label className="col-md-2 col-form-label">Occupation</Label>
																<Col md={8}>
																	<select
																		className="custom-select"
																		id="occupationId"
																		onChange={event => {
																			this.tempStateHandling(event, this.state.activeTab - 1)
																		}}
																		value={this.state.occupationId}>
																		{this.state.formFieldData.occupations.map((data, id) => (
																			<option key={id} value={data.occupationId}>
																				{data.occupationEN}
																			</option>
																		))}
																	</select>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label className="col-md-2 col-form-label">Level Religiousity</Label>
																<Col md={8}>
																	<select
																		className="custom-select"
																		id="religiosity"
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}
																		value={this.state.sections[4].religiosity}>
																		{this.state.formFieldData.religiousTypes.map((data, id) => (
																			<option key={id} value={data.rId}>
																				{data.rEN}
																			</option>
																		))}
																	</select>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label className="col-md-2 col-form-label">Marital Status</Label>
																<Col md={8}>
																	<select
																		className="custom-select"
																		id="maritalStatus"
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}
																		value={this.state.sections[4].maritalStatus}>
																		{this.state.formFieldData.maritalStatus.map((data, id) => (
																			<option key={id} value={data.mid}>
																				{data.status_en}
																			</option>
																		))}
																	</select>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label className="col-md-2 col-form-label">Educational background</Label>
																<Col md={8}>
																	<select
																		className="custom-select"
																		id="educationLevel"
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}
																		value={this.state.sections[4].educationLevel}>
																		{this.state.formFieldData.educations.map((data, id) => (
																			<option key={id} value={data.educationId}>
																				{data.educationEN}
																			</option>
																		))}
																	</select>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label className="col-md-2 col-form-label">Mandarin Chinese Proficiency</Label>
																<Col md={8}>
																	<select
																		className="custom-select"
																		id="chineseLanguageSkills"
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}
																		value={this.state.sections[4].chineseLanguageSkills}>
																		{this.state.formFieldData.languageSkills.map((data, id) => (
																			<option key={id} value={data.lid}>
																				{data.skillEN}
																			</option>
																		))}
																	</select>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label className="col-md-2 col-form-label">Communist Party Membership?</Label>
																<Col md={8}>
																	<select
																		className="custom-select"
																		id="partyMember"
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}
																		value={this.state.sections[4].partyMember}>
																			<option value={-1}>Unknown</option>
																			<option value={0}>No</option>
																			<option value={1}>Yes</option>
																	</select>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
																	Number of children
																</Label>
																<Col md={8}>
																	<Input
																		className="form-control"
																		type="number"
																		placeholder="Number Of Children"
																		id="numberOfChildren"
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}
																		value={this.state.sections[4].numberOfChildren}
																	/>
																</Col>
															</FormGroup>
															<ul className="pager wizard twitter-bs-wizard-pager-link">
																<li className="previous">
																	<Button
																		to="#"
																		onClick={() => {
																			this.toggleTab(this.state.activeTab - 1, 0);
																		}}>
																		Previous
																	</Button>
																</li>
																<li className="next">
																	<Button to="#" disabled={!this.state.submittedSection1} type="submit">
																		Submit & Next
																	</Button>
																</li>
															</ul>
														</AvForm>
													</TabPane>

													<TabPane tabId={6}>
														<CardTitle className="h5 mb-3 text-center">Travel History - Victim</CardTitle>
														<AvForm
															className="form-horizontal"
															onValidSubmit={() => {
																this.toggleTab(this.state.activeTab + 1, 1);
															}}>
															<FormGroup row onChange={event => this.stateHandling(event, this.state.activeTab - 1)}>
																<Label className="col-md-2 col-form-label">Has family member(s), relative(s) abroad?</Label>
																<Col md={3}>
																	<div className="custom-control custom-radio mb-3">
																		<Input
																			type="radio"
																			id="haveFamilyAbroadYes"
																			value={1}
																			name="haveFamilyAbroad"
																			checked={this.state.sections[5].haveFamilyAbroad === 1}
																			className="custom-control-input"
																		/>
																		<Label className="custom-control-label" htmlFor="haveFamilyAbroadYes">
																			Yes
																		</Label>
																	</div>
																</Col>
																<Col md={3}>
																	<div className="custom-control custom-radio mb-3">
																		<Input
																			type="radio"
																			id="haveFamilyAbroadNo"
																			value={0}
																			name="haveFamilyAbroad"
																			checked={this.state.sections[5].haveFamilyAbroad === 0}
																			className="custom-control-input"
																		/>
																		<Label className="custom-control-label" htmlFor="haveFamilyAbroadNo">
																			No
																		</Label>
																	</div>
																</Col>
																<Col md={3}>
																	<div className="custom-control custom-radio mb-3">
																		<Input
																			type="radio"
																			id="haveFamilyAbroadUnknown"
																			value={-1}
																			name="haveFamilyAbroad"
																			checked={this.state.sections[5].haveFamilyAbroad === -1}
																			className="custom-control-input"
																		/>
																		<Label className="custom-control-label" htmlFor="haveFamilyAbroadUnknown">
																			Unknown
																		</Label>
																	</div>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label className="col-md-2 col-form-label">Traveled Abroad</Label>
																<Col md={8}>
																	<select
																		className="custom-select"
																		id="abroadTravel"
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}
																		value={this.state.sections[5].abroadTravel}>
																		<option value={0}>None</option>
																		<option value={1}>I Dont Know</option>
																		<option value={2}>Yes</option>
																		<option value={3}>No</option>
																	</select>
																</Col>
															</FormGroup>
															{this.state.sections[5].abroadTravel === 2 ? (
																<FormGroup row>
																	<Label className="col-md-2 col-form-label">Select Visited Countries</Label>
																	<Col md={8}>
																		<Select
																			isMulti
																			name="colors"
																			className="basic-multi-select"
																			classNamePrefix="select"
																			options={this.state.formFieldData.countries.map((option, idx) => ({
																				value: option.countryId,
																				label: option.countryName,
																			}))}
																			onChange={selected => {
																				this.stateSelect(selected, 6);
																			}}
																		/>
																	</Col>
																</FormGroup>
															) : (
																''
															)}
															<FormGroup row>
																<Label htmlFor="additional-information" md="2" className="form-label">
																	Additional Information
																</Label>
																<Col md={8}>
																	<Input
																		type="textarea"
																		id="additionalInfo"
																		maxLength="1000"
																		rows="3"
																		placeholder="Any information about abroad travel/family members"
																		value={this.state.sections[5].additionalInfo}
																		onChange={event => this.stateHandling(event, this.state.activeTab - 1)}
																	/>
																</Col>
															</FormGroup>
															<ul className="pager wizard twitter-bs-wizard-pager-link">
																<li className="previous">
																	<Button
																		to="#"
																		onClick={() => {
																			this.toggleTab(this.state.activeTab - 1, 0);
																		}}>
																		Previous
																	</Button>
																</li>
																<li className="next">
																	<Button to="#" disabled={!this.state.submittedSection1} type="submit">
																		Submit & Next
																	</Button>
																</li>
															</ul>
														</AvForm>
													</TabPane>

													<TabPane tabId={7}>
														<CardTitle className="h5 mb-3 text-center">Detention Information - Victim</CardTitle>
														<AvForm
															className="form-horizontal"
															onValidSubmit={() => {
																this.toggleTab(this.state.activeTab + 1, 1);
															}}>
															<Card>
																<CardBody>
																	<FormGroup row>
																		<Label className="col-md-2 col-form-label">Detention Status</Label>
																		<Col md={9}>
																			<select
																				className="custom-select"
																				id="tempDetentionStatusId"
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																				value={this.state.tempDetentionStatusId}>
																				{this.state.formFieldData.victimStatus.map((data, id) => (
																					<option key={id} value={data.id}>
																						{data.statusEN}
																					</option>
																				))}
																			</select>
																		</Col>
																	</FormGroup>
																	{this.state.tempDetentionStatusId === '1' ? (
																		<FormGroup row>
																			<Label className="col-md-2 col-form-label">Detention Status Other</Label>
																			<Col md={9}>
																				<Input
																					type="textarea"
																					id="tempDetentionOther"
																					rows="1"
																					placeholder="Any other clarification such as what he/she was doing while this event occured"
																					value={this.state.tempDetentionOther}
																					onChange={event => {
																						this.tempStateHandling(event);
																					}}
																				/>
																			</Col>
																		</FormGroup>
																	) : (
																		''
																	)}
																	<FormGroup row>
																		<Label htmlFor="denetention-clarification" md="2" className="form-label">
																			Reason for arrest (detention)
																		</Label>
																		<Col md={9}>
																			<Input
																				type="textarea"
																				id="tempDetentionReason"
																				rows="3"
																				placeholder="Reason for detention"
																				value={this.state.tempDetentionReason}
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="denetention-clarification" md="2" className="form-label">
																			Additional info/Clarification
																		</Label>
																		<Col md={9}>
																			<Input
																				type="textarea"
																				id="tempDetentionClarification"
																				rows="3"
																				placeholder="Any other clarification such as what he/she was doing while this event occured"
																				value={this.state.tempDetentionClarification}
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="denetention-clarification" md="2" className="form-label">
																			Source of Information
																		</Label>
																		<Col md={9}>
																			<Input
																				type="textarea"
																				id="tempDetentionPossesionOfInformation"
																				rows="3"
																				placeholder="How the information was gathered"
																				value={this.state.tempDetentionPossesionOfInformation}
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="denetention-clarification" md="2" className="form-label">
																			Detention Address
																		</Label>
																		<Col md={9}>
																			<Input
																				type="textarea"
																				id="tempDetentionAddress"
																				rows="3"
																				placeholder="How the information was gathered"
																				value={this.state.tempDetentionAddress}
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label className="col-md-2 col-form-label">Location</Label>
																		<Col md={9}>
																			<select
																				className="custom-select"
																				id="tempDetentionLocationId"
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																				value={this.state.tempDetentionLocationId}>
																				{this.state.formFieldData.internmentLocations.map((data, id) => (
																					<option key={id} value={data.id}>
																						{data.name}
																					</option>
																				))}
																			</select>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
																			Arrest (detention), Date From
																		</Label>
																		<Col md={3}>
																			<Input
																				className="form-control"
																				type="number"
																				placeholder="Year"
																				id="tempDetentionStatusYearFrom"
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																				value={this.state.tempDetentionStatusYearFrom}
																			/>
																		</Col>
																		<Col md={3}>
																			<Input
																				className="form-control"
																				type="number"
																				placeholder="Month"
																				id="tempDetentionStatusMonthFrom"
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																				value={this.state.tempDetentionStatusMonthFrom}
																			/>
																		</Col>
																		<Col md={3}>
																			<Input
																				className="form-control"
																				type="number"
																				placeholder="Day"
																				id="tempDetentionStatusDayFrom"
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																				value={this.state.tempDetentionStatusDayFrom}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
																			Arrest (detention), Date To
																		</Label>
																		<Col md={3}>
																			<Input
																				className="form-control"
																				type="number"
																				placeholder="Year"
																				id="tempDetentionStatusYearTo"
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																				value={this.state.tempDetentionStatusYearTo}
																			/>
																		</Col>
																		<Col md={3}>
																			<Input
																				className="form-control"
																				type="number"
																				placeholder="Month"
																				id="tempDetentionStatusMonthTo"
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																				value={this.state.tempDetentionStatusMonthTo}
																			/>
																		</Col>
																		<Col md={3}>
																			<Input
																				className="form-control"
																				type="number"
																				placeholder="Day"
																				id="tempDetentionStatusDayTo"
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																				value={this.state.tempDetentionStatusDayTo}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																			Document
																		</Label>
																		<Col md={9}>
																			<div className="custom-file mb-2">
																				<CustomInput
																					type="file"
																					className="custom-file-input"
																					id="tempDetentionFileHolder"
																					onChange={event => {
																						this.fileHandling(event, 'detention');
																					}}
																				/>
																				<Label className="custom-file-label" htmlFor="tempDetentionFileHolder">
																					Choose file
																				</Label>
																			</div>
																		</Col>
																		<Col md={9}>
																			<div className="text-center">
																				{this.state.tempDetentionDocument !== '' ? (
																					<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																						{this.state.tempDetentionDocument.substr(this.state.tempDetentionDocument.length - 3)} Ready
																					</Label>
																				) : (
																					// this.state.tempDocumentLocation.substr(this.state.tempDocumentLocation.length - 3) === "pdf" ?
																					//     <Label htmlFor="example-text-input" className="col-md-2 col-form-label">Uploaded PDF</Label>
																					//     :
																					//     <CardImg top width="100%" src={this.state.tempDocumentLocation} />
																					''
																				)}
																			</div>
																		</Col>
																	</FormGroup>
																	<FormGroup className="text-center">
																		<Button
																			color="primary"
																			type="button"
																			className="waves-effect waves-light me-1"
																			onClick={() => {
																				this.addTempStateToSections(this.state.activeTab - 1);
																			}}>
																			Add <i className="ri-arrow-right-line align-middle ms-2"></i>
																		</Button>
																	</FormGroup>
																</CardBody>
															</Card>
															<Alert
																id="success"
																color="success"
																isOpen={this.state.sectionObjectDeleteStatus}
																toggle={e => {
																	this.setState({ sectionObjectDeleteStatus: !this.state.sectionObjectDeleteStatus });
																}}>
																{this.state.sectionObjectDeleteMessage}
															</Alert>
															<Row>
																{this.state.sections[6].map((element, id) => (
																	<Col lg={6} sm={6}>
																		<Card className="border rounded shipping-address" key={id}>
																			<CardBody>
																				<div className="text-center">
																					<Button
																						color="light"
																						className="waves-effect me-1 align-center"
																						onClick={() => {
																							this.tempStateEdit(this.state.activeTab - 1, id);
																						}}>
																						<div className="text-center">Edit</div>
																					</Button>
																				</div>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 text-left">Detention Status</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 text-right">{element.statusId}</h5>
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 text-left">Detention Status Other</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 text-right">{element.other}</h5>
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-left">Clarification</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-right">{element.clarification}</h5>
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-left">Reason</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-right">{element.reason}</h5>
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-left">Address</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-right">{element.detentionAddress}</h5>
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-left">Date From</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-right">
																							{element.detainedFromYear}-{element.detainedFromMonth}-{element.detainedFromDay}
																						</h5>
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-left">Date To</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-right">
																							{element.detainedToYear}-{element.detainedToMonth}-{element.detainedToDay}
																						</h5>
																					</Col>
																				</Row>
																				<div className="text-center">
																					<Button
																						color="light"
																						className="waves-effect me-1 align-center"
																						onClick={() => {
																							if (window.confirm('Are you sure you want to delete this address?'))
																								this.addressDelete(
																									this.state.activeTab - 1,
																									id,
																									'detention',
																									this.state.sections[this.state.activeTab - 1][id].detentionId,
																									this.state.sections[this.state.activeTab - 1][id].victimId
																								);
																						}}>
																						<div className="text-center">Delete</div>
																					</Button>
																				</div>
																			</CardBody>
																		</Card>
																	</Col>
																))}
															</Row>
															<ul className="pager wizard twitter-bs-wizard-pager-link">
																<li className="previous">
																	<Button
																		to="#"
																		onClick={() => {
																			this.toggleTab(this.state.activeTab - 1, 0);
																		}}>
																		Previous
																	</Button>
																</li>
																<li className="next">
																	<Button to="#" disabled={!this.state.submittedSection1} type="submit">
																		Submit & Next
																	</Button>
																</li>
															</ul>
														</AvForm>
													</TabPane>

													<TabPane tabId={8}>
														<CardTitle className="h5 mb-3 text-center">Reference - Testifier</CardTitle>
														<AvForm
															className="form-horizontal"
															onValidSubmit={() => {
																this.toggleTab(this.state.activeTab + 1, 1);
															}}>
															<Card>
																<CardBody>
																	<FormGroup row>
																		<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
																			Firstname
																		</Label>
																		<Col md={9}>
																			<Input
																				className="form-control"
																				type="text"
																				placeholder="Firstname"
																				id="tempReferenceFirstname"
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																				value={this.state.tempReferenceFirstname}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
																			Lastname
																		</Label>
																		<Col md={9}>
																			<Input
																				className="form-control"
																				type="text"
																				placeholder="Lastname"
																				id="tempReferenceLastname"
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																				value={this.state.tempReferenceLastname}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
																			Age
																		</Label>
																		<Col md={9}>
																			<Input
																				className="form-control"
																				type="number"
																				placeholder="Age"
																				id="tempReferenceAge"
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																				value={this.state.tempReferenceAge}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup
																		row
																		onChange={event => {
																			this.tempStateHandling(event);
																		}}>
																		<Label className="col-md-2 col-form-label">Gender</Label>
																		<Col md={4}>
																			<div className="custom-control custom-radio mb-3">
																				<Input
																					type="radio"
																					id="TempReferenceGenderMale"
																					value={3}
																					name="tempReferenceGender"
																					checked={this.state.tempReferenceGender === 3}
																					className="custom-control-input"
																				/>
																				<Label className="custom-control-label" htmlFor="TempReferenceGenderMale">
																					Male
																				</Label>
																			</div>
																		</Col>
																		<div className="custom-control custom-radio mb-3">
																			<Input
																				type="radio"
																				id="TempReferenceGenderFemale"
																				value={2}
																				name="tempReferenceGender"
																				checked={this.state.tempReferenceGender === 2}
																				className="custom-control-input"
																			/>
																			<Label className="custom-control-label" htmlFor="TempReferenceGenderFemale">
																				Female
																			</Label>
																		</div>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
																			City of Residence
																		</Label>
																		<Col md={9}>
																			<Input
																				className="form-control"
																				type="text"
																				placeholder="Place of birth city"
																				id="tempReferencePlaceOfBirth"
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																				value={this.state.tempReferencePlaceOfBirth}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label className="col-md-2 col-form-label">Country of Residence</Label>
																		<Col md={9}>
																			<select
																				className="custom-select"
																				id="tempReferencePlaceOfBirthId"
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																				value={this.state.tempReferencePlaceOfBirthId}>
																				{this.state.formFieldData.countries.map((data, id) => (
																					<option key={id} value={data.countryId}>
																						{data.countryName}
																					</option>
																				))}
																			</select>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
																			Relation to the victim
																		</Label>
																		<Col md={9}>
																			<Input
																				className="form-control"
																				type="text"
																				placeholder="Relation"
																				id="tempReferenceRelation"
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																				value={this.state.tempReferenceRelation}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
																			Email
																		</Label>
																		<Col md={9}>
																			<Input
																				className="form-control"
																				type="email"
																				placeholder="Email"
																				id="tempReferenceEmail"
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																				value={this.state.tempReferenceEmail}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
																			Phone Number
																		</Label>
																		{/* <PhoneInput
                                                        country={'us'}
                                                        value={this.state.phone}
                                                        onChange={phone => this.setState({ phone })}
                                                    /> */}
																		<Col md={3}>
																			<select
																				className="custom-select"
																				id="tempPhoneCode"
																				onChange={event => {
																					this.tempPhoneCodeChange(event);
																				}}
																				value={this.state.tempPhoneCode}>
																				{this.state.formFieldData.countries.map((data, id) => (
																					<option key={id} value={data.countryName}>
																						{data.countryName}
																					</option>
																				))}
																			</select>
																		</Col>
																		<Col md={6}>
																			<Input
																				className="form-control"
																				type="number"
																				placeholder="Phone Number"
																				id="tempReferenceMobile"
																				onChange={event => {
																					this.tempStateHandling(event);
																				}}
																				value={this.state.tempReferenceMobile}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup className="text-center">
																		<Button
																			color="primary"
																			type="button"
																			className="waves-effect waves-light me-1"
																			onClick={() => {
																				this.addTempStateToSections(this.state.activeTab - 1);
																			}}>
																			Add <i className="ri-arrow-right-line align-middle ms-2"></i>
																		</Button>
																	</FormGroup>
																</CardBody>
															</Card>
															<Alert
																id="success"
																color="success"
																isOpen={this.state.sectionObjectDeleteStatus}
																toggle={e => {
																	this.setState({ sectionObjectDeleteStatus: !this.state.sectionObjectDeleteStatus });
																}}>
																{this.state.sectionObjectDeleteMessage}
															</Alert>
															<Row>
																{this.state.sections[7].map((element, id) => (
																	<Col lg={6} sm={6}>
																		<Card className="border rounded shipping-address" key={id}>
																			<CardBody>
																				<div className="text-center">
																					<Button
																						color="light"
																						className="waves-effect me-1 align-center"
																						onClick={() => {
																							this.tempStateEdit(this.state.activeTab - 1, id);
																						}}>
																						<div className="text-center">Edit</div>
																					</Button>
																				</div>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 text-left">Firstname</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 text-right">{element.person.firstName}</h5>
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 text-left">Lastname</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 text-right">{element.person.lastName}</h5>
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-left">Gender</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-right">{element.person.gender}</h5>
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-left">Country</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-right">{element.person.placeOfBirthId}</h5>
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-left">Relation</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-right">{element.relation}</h5>
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-left">Email</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-right">{element.email}</h5>
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-left">Phone</h5>
																					</Col>
																					<Col>
																						<h5 className="font-size-14 mb-4 text-right">{element.mobile}</h5>
																					</Col>
																				</Row>
																				<div className="text-center">
																					<Button
																						color="light"
																						className="waves-effect me-1 align-center"
																						onClick={() => {
																							if (window.confirm('Are you sure you want to delete this address?'))
																								this.addressDelete(
																									this.state.activeTab - 1,
																									id,
																									'relation',
																									this.state.sections[this.state.activeTab - 1][id].contactId,
																									this.state.sections[this.state.activeTab - 1][id].victimId
																								);
																						}}>
																						<div className="text-center">Delete</div>
																					</Button>
																				</div>
																			</CardBody>
																		</Card>
																	</Col>
																))}
															</Row>
															<ul className="pager wizard twitter-bs-wizard-pager-link">
																<li className="previous">
																	<Button
																		to="#"
																		onClick={() => {
																			this.toggleTab(this.state.activeTab - 1, 0);
																		}}>
																		Previous
																	</Button>
																</li>
																<li className="next">
																	<Button to="#" disabled={!this.state.submittedSection1} type="submit">
																		Submit & Next
																	</Button>
																</li>
															</ul>
														</AvForm>
													</TabPane>

													<TabPane tabId={9}>
														<CardTitle className="h5 mb-3 text-center">Consent</CardTitle>
														<AvForm
															className="form-horizontal"
															onValidSubmit={() => {
																this.toggleTab(this.state.activeTab + 1, 1);
															}}>
															{this.state.sections[8]
																? this.state.sections[8].map((each, idx) => (
																		<Card>
																			<CardBody className="text-center">
																				<Row>
																					<Col>
																						<Label className="col-form-label">{each.consentName}</Label>
																						<hr width="20%" />
																					</Col>
																				</Row>

																				<Row>
																					<Col>
																						<Label className="col-form-label">{each.description}</Label>
																						<hr width="90%" />
																					</Col>
																				</Row>
																				<Row>
																					<Col>
																						<Label className="col-form-label">{each.clarification}</Label>
																						<hr width="90%" />
																					</Col>
																				</Row>
																				<FormGroup
																					row
																					onChange={event => {
																						this.concentAcceptedUpdate(event, idx);
																					}}>
																					<Col md={6}>
																						<div className="custom-control custom-radio mb-6">
																							<Input
																								type="radio"
																								id={'ConcentAcceptedTrue' + idx}
																								value={1}
																								name={'ConcentAcceptedTrueName' + idx}
																								className="custom-control-input"
																							/>
																							<Label className="custom-control-label" htmlFor={'ConcentAcceptedTrue' + idx}>
																								Yes
																							</Label>
																						</div>
																					</Col>
																					<div className="custom-control custom-radio mb-6">
																						<Input
																							type="radio"
																							id={'ConcentAcceptedFalse' + idx}
																							value={0}
																							name={'ConcentAcceptedTrueName' + idx}
																							className="custom-control-input"
																						/>
																						<Label className="custom-control-label" htmlFor={'ConcentAcceptedFalse' + idx}>
																							No
																						</Label>
																					</div>
																				</FormGroup>
																			</CardBody>
																		</Card>
																  ))
																: ''}
															<ul className="pager wizard twitter-bs-wizard-pager-link">
																<li className="previous">
																	<Button
																		to="#"
																		onClick={() => {
																			this.toggleTab(this.state.activeTab - 1, 0);
																		}}>
																		Previous
																	</Button>
																</li>
																<li className="next">
																	<Button to="#" disabled={!this.state.submittedSection1} type="submit">
																		Submit & Next
																	</Button>
																</li>
															</ul>
														</AvForm>
													</TabPane>

													<TabPane tabId={10}>
														<CardTitle className="h5 mb-3 text-center">Internal Assessment</CardTitle>
														{/* <AvForm className="form-horizontal" onValidSubmit={() => {this.toggleTab(this.state.activeTab + 1, 1);}} > */}
														<AvForm
															className="form-horizontal"
															onValidSubmit={() => {
																if (window.confirm('Submit and Go Back To Main Page')) this.toggleTab(this.state.activeTab + 1, 1);
															}}>
															<FormGroup row>
																<Label htmlFor="denetention-clarification" md="2" className="form-label">
																	Assessment
																</Label>
																<Col md={9}>
																	<Input
																		type="textarea"
																		id="assessment"
																		rows="2"
																		placeholder="Assessment Evaluation"
																		value={this.state.sections[9].assessment}
																		onChange={event => {
																			this.assessmentStateSectionChange(event);
																		}}
																	/>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label className="col-md-2 col-form-label">Tags</Label>
																<Col md={9}>
																	<Select
																		isMulti
																		name="colors"
																		className="basic-multi-select"
																		classNamePrefix="select"
																		options={this.state.tempAssessmentMultiSelect.map((option, idx) => ({
																			value: option.tagId,
																			label: option.tagName,
																		}))}
																		onChange={selected => {
																			this.stateSelect(selected, 10);
																		}}
																	/>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label htmlFor="denetention-clarification" md="2" className="form-label">
																	Assessment Notes
																</Label>
																<Col md={9}>
																	<Input
																		type="textarea"
																		id="note"
																		rows="2"
																		placeholder="Note"
																		value={this.state.sections[9].note}
																		onChange={event => {
																			this.assessmentStateSectionChange(event);
																		}}
																	/>
																</Col>
															</FormGroup>
															<FormGroup row>
																<Label htmlFor="example-number-input" className="col-md-2 col-form-label">
																	Signature
																</Label>
																<Col md={9}>
																	<Input
																		className="form-control"
																		type="text"
																		placeholder="Signature"
																		id="signature"
																		onChange={event => {
																			this.assessmentStateSectionChange(event);
																		}}
																		value={this.state.sections[9].signature}
																	/>
																</Col>
																<Col md={12}>
																	<div className="mt-5 text-center">
																		{this.state.confirmMessage === "" ? "" 
																		:  <Alert color="success">
																			{this.state.confirmMessage}
																			</Alert>
																			}
																		
																	</div>
																</Col>
																
															</FormGroup>
															<ul className="pager wizard twitter-bs-wizard-pager-link">
																<li className="previous">
																	<Button
																		to="#"
																		onClick={() => {
																			this.toggleTab(this.state.activeTab - 1, 0);
																		}}>
																		Previous
																	</Button>
																</li>
																<li className="next">
																	<Button to="#" disabled={!this.state.submittedSection1} type="submit">
																		Submit & Finish
																	</Button>
																</li>
															</ul>
															
														</AvForm>
													</TabPane>
												</TabContent>
											</div>
										</CardBody>
									</Card>
								</Col>

								<Col lg="4">
									<Card className="checkout-order-summary">
										<CardBody>
											<div className="p-3 bg-light mb-4">
												<h5 className="font-size-14 mb-0">
													Name:{' '}
													<span className="float-right ms-2">
														{this.props.location.state?.firstname
															? this.props.location.state?.firstname
															: this.state.sections[0].firstname + ' '}
														{this.props.location.state?.lastname ? this.props.location.state?.lastname : this.state.sections[0].lastname}
													</span>
												</h5>
											</div>
											<div className="table-responsive">
												<Table className="align-middle mb-0 table-nowrap">
													<thead className="table-light">
														<tr>
															<th style={{ width: '50px' }} scope="col">
																Icon
															</th>
															<th scope="col">Section</th>
															<th scope="col">Status</th>
														</tr>
													</thead>
													<tbody>
														{this.state.sectionMenu.map((orderitem, key) => (
															<tr key={'_sectionMenu_' + key}>
																<th scope="row">
																	<i className={orderitem.icon}></i>
																</th>
																<td>
																	<h5 className="font-size-14 text-left ">
																		<NavLink
																			style={{ color: '#343a40' }}
																			className={classnames({
																				active: this.state.activeTab === orderitem.id,
																			})}
																			onClick={() => {
																				this.toggleTab(orderitem.id, 0);
																			}}>
																			{orderitem.sectionTitle}{' '}
																		</NavLink>
																	</h5>
																</td>
																{orderitem.status ? (
																	<td style={{ color: 'green' }}>Completed</td>
																) : (
																	<td style={{ color: 'red' }}>Incomplete</td>
																)}
															</tr>
														))}
														<tr>
															<td colSpan="2">
																<h6 className="m-0 text-end">Process</h6>
															</td>
															<td> {parseInt((this.state.success.filter(Boolean).length / this.state.success.length) * 100)} % </td>
														</tr>
													</tbody>
												</Table>
											</div>
										</CardBody>
									</Card>
									<Card>
										<CardBody>
											<thead className="table-light">
												<tr onClick={() => this.setState({ openExtraSection: !this.state.openExtraSection })}>
													<th scope="col">Field Name</th>
													<th>  
                                                    	<i className={this.state.openExtraSection === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
													</th>
												</tr>
											</thead>
											<hr/>
											<Collapse isOpen={this.state.openExtraSection} id="collapseTwo">
												<tbody>
													<tr><th>Job Title</th><td className="col-md-8">{this.state.unFields.extraJobTitle}</td></tr><hr/>
													<tr><th>Economy Situation</th><td className="col-md-8">{this.state.unFields.extraEconomySituation}</td></tr><hr/>
													<tr><th>Family Info</th><td className="col-md-8">{this.state.unFields.extraFamilyInfo}</td></tr><hr/>
													<tr><th>Current Situation</th><td className="col-md-8">{this.state.unFields.extraCurrentSituation}</td></tr><hr/>
													<tr><th>Place of Imprisonment</th><td className="col-md-8">{this.state.unFields.extraPlaceOfImprisonment}</td></tr><hr/>
													<tr><th>Reason for Detainment</th><td className="col-md-8">{this.state.unFields.extraReasonForDetainment}</td></tr><hr/>
													<tr><th>Original Health Situation</th><td className="col-md-8">{this.state.unFields.extraHealthSituation}</td></tr><hr/>
													<tr><th>Is Released</th><td className="col-md-8">{this.state.unFields.extraReleased}</td></tr><hr/>
													<tr><th>Have Passport</th><td className="col-md-8">{this.state.unFields.extraHavePassport}</td></tr><hr/>
													<tr><th>Country Testifier Lives In</th><td className="col-md-8">{this.state.unFields.extraSelfCountry}</td></tr><hr/>
												</tbody>
											</Collapse>
										</CardBody>
									</Card>
								</Col>
							</Row>
						</Container>
					</div>
				</React.Fragment>
			);
		} else if (this.state.loading === true) {
			return (
				<React.Fragment>
					<div className="page-content">
						<Container fluid>
							<h1 className="h3 mb-3 text-center">Loading</h1>
						</Container>
					</div>
				</React.Fragment>
			);
		} else {
			return (
				<React.Fragment>
					<div className="page-content">
						<Container fluid>
							<h1 className="h3 mb-3 text-center">Failed to open component. Contact developers.</h1>
						</Container>
					</div>
				</React.Fragment>
			);
		}
	}
}
